/**
 * Fixed palette for initials.
 *
 * Not tokens: these are identity colours, not semantic ones. A person's avatar colour
 * carries no meaning about state, and tying them to the status palette would make it
 * look as though it did.
 */
const TONES = [
  '#4b5bc4',
  '#3c6e63',
  '#7a5a9e',
  '#8a6234',
  '#2e6e8e',
  '#9e5a5a',
  '#4f7a3c',
  '#6b5ba8',
] as const;

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).slice(0, 2);
  const letters = parts.map((part) => part[0] ?? '').join('');
  return letters.toUpperCase() || '?';
}

/** Same name, same colour, on every screen and in every session. */
export function toneFor(seed: string): string {
  let hash = 0;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 31 + seed.charCodeAt(index)) % 997;
  }
  return TONES[hash % TONES.length] as string;
}
